export const PREMIUM_LOAD = '@@home/PREMIUM_LOAD';
export const META_LOAD = '@@home/META';
export const DOMAINS_LOAD = '@@home/DOMAINS_LOAD';

export const CIAN_REDIRECT_URL_LOAD = 'CIAN_REDIRECT_URL_LOAD';



// WEBPACK FOOTER //
// ./src/app/Home/actionTypes.js